import { HStack, Icon, StackProps } from "@chakra-ui/react";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";

interface Props extends StackProps {
  value?: number;
  max?: number;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  activeColor?: string;
  defaultColor?: string;
}

const determineIcon = (
  index: number,
  value: number,
  activeColor?: string,
  defaultColor?: string,
) => {
  const reminder = Math.abs(index - value);
  if (index <= value) return { icon: FaStar, color: activeColor };
  else if (reminder > 0 && reminder <= 0.2)
    return { icon: FaStar, color: activeColor };
  else if (reminder > 0.2 && reminder <= 0.6)
    return { icon: FaStarHalfAlt, color: activeColor };
  else return { icon: FaStar, color: defaultColor };
};

export const Rating = (props: Props) => {
  const {
    value = 0,
    max = 5,
    size = "md",
    activeColor = "gold.500",
    defaultColor = "gray.200",
    ...rest
  } = props;
  return (
    <HStack spacing="0.5" {...rest} justify="center">
      {Array.from({ length: max })
        .map((_, index) => index + 1)
        .map((index) => {
          const { icon, color } = determineIcon(
            index,
            value,
            activeColor,
            defaultColor,
          );
          return <Icon key={index} as={icon} fontSize={size} color={color} />;
        })}
    </HStack>
  );
};
